<section id="banner">
  <div class="banner-shadow"></div>
  <div class="keen-slider" #sliderRef>
    <div class="keen-slider__slide slide slide1"></div>
    <div class="keen-slider__slide slide slide2"></div>
    <div class="keen-slider__slide slide slide3"></div>
    <div class="keen-slider__slide slide slide4"></div>
  </div>
</section>
